<template lang="pug">
#editar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.titulo")',
        :voltarPara='true',
        :exibeBotao='false'
    )

    .view-container
        section.editar-contrato-originacao__body
            .editar-contrato-originacao__card
                h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
                el-card(
                    :body-style='{ padding: "20px" }',
                    shadow='never',
                    v-loading='carregando'
                )
                    FormEmpresaEditarContratoAlvorada(
                        v-if='isAlvorada',
                        :opcoes='opcoes',
                        :contrato='(formEdicaoContrato.id && formEdicaoContrato) || {}',
                        @buscarMunicipios='buscarMunicipios'
                    )
                    el-form.col-12(
                        v-else,
                        label-position='top',
                        :model='formEdicaoContrato',
                        :rules='formEdicaoContratoRegras',
                        ref='formEdicaoContratoRef'
                    )
                        .row
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")'
                            )
                                el-input(
                                    disabled,
                                    v-if='isBunge',
                                    v-model='formEdicaoContrato.numeroContrato',
                                    v-mask='"##########"',
                                    placeholder='1000100000'
                                )

                                el-input(
                                    disabled,
                                    v-if='!isBunge && getTrading === "BE8"',
                                    v-model='formEdicaoContrato.numeroContrato',
                                    v-mask='"##########"',
                                    placeholder='1000100000'
                                )

                                el-input(
                                    disabled,
                                    v-if='!isBunge && getTrading !== "BE8"',
                                    v-model='formEdicaoContrato.numeroContrato',
                                    v-mask='"#######-###"',
                                    placeholder='0000001-100'
                                )

                            el-form-item.col-2(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura")',
                                prop='cultura'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.cultura',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.culturas',
                                        :key='id + nome',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-1(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra")',
                                prop='safra'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.safra',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ ano, id } in opcoes.safras',
                                        :key='id + ano',
                                        :label='ano',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
                                prop='volumeContratado'
                            )
                                el-input(
                                    v-model='formEdicaoContrato.volumeContratado',
                                    @blur='volumeContratadoFormatado'
                                )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeRecebido")',
                                prop='volumeRecebido'
                            )
                                el-input(
                                    v-model='formEdicaoContrato.volumeRecebido',
                                    @blur='volumeRecebidoFormatado'
                                )
                        .row
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.valorContrato")',
                                prop='valorContrato'
                            )
                                el-input(
                                    v-model='formEdicaoContrato.valorContrato',
                                    @blur='valorContratoFormatado'
                                )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataPagamento")',
                                prop='dataPagamento'
                            )
                                el-date-picker(
                                    v-model='formEdicaoContrato.dataPagamento',
                                    type='date',
                                    placeholder='Selecione',
                                    format='dd/MM/yyyy'
                                )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.condicaoFrete")',
                                prop='condicaoFrete'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.condicaoFrete',
                                    clearable,
                                    filterable
                                )
                                    el-option(label='CIF', value='CIF')
                                    el-option(label='FOB', value='FOB')

                            el-form-item.col-3(
                                :label=`formEdicaoContrato.condicaoFrete ? (formEdicaoContrato.condicaoFrete === "CIF"
                                ? $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeEntrega")
                                : $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeRetirada"))
                                : $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localCondicaoFrete")`,
                                prop='localCondicaoFrete'
                            )
                                el-input(
                                    v-model='formEdicaoContrato.localCondicaoFrete'
                                )

                        .row
                            el-form-item.col-1(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.estado")',
                                prop='estado'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.estado',
                                    @change='alteradoEstado',
                                    @clear='alteradoEstado',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ sigla, id } in opcoes.estados',
                                        :key='id + sigla',
                                        :label='sigla',
                                        :value='id'
                                    )

                            el-form-item.col-2(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localidade")',
                                prop='municipio'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.municipio',
                                    :disabled='!formEdicaoContrato.estado',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.municipios',
                                        :key='id + nome',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataContrato")',
                                prop='dataContrato'
                            )
                                el-date-picker(
                                    v-model='formEdicaoContrato.dataContrato',
                                    type='date',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    format='dd/MM/yyyy',
                                    :picker-options='pickerOptionsDataContrato'
                                )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor")',
                                prop='fornecedor'
                            )
                                el-select#fornecedor(
                                    v-model='formEdicaoContrato.fornecedor',
                                    value-key='id',
                                    :loading='loading.fornecedor',
                                    @change='definirCnpjFornecedor',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='fornecedor in opcoes.fornecedores',
                                        :key='fornecedor.id + fornecedor.nome',
                                        :id='"fornecedor-" + fornecedor.id',
                                        :label='fornecedor.nome',
                                        :value='fornecedor'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cnpjFornecedor")',
                                prop='cnpjFornecedor'
                            )
                                el-select#cnpjFornecedor(
                                    v-model='formEdicaoContrato.cnpjFornecedor',
                                    :disabled='!formEdicaoContrato.fornecedor',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='(cnpj, index) in opcoes.cnpjFornecedores',
                                        :key='cnpj',
                                        :id='"cnpjFornecedor-" + index',
                                        :label='cnpj',
                                        :value='cnpj'
                                    )

                        .row
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.segmento")',
                                prop='segmento'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.segmento',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id, codigo } in opcoes.segmentos',
                                        :key='id + nome',
                                        :label='`${nome} - ${codigo}`',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.canal")',
                                prop='canal'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.canal',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.canais',
                                        :key='id + nome',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.regional")',
                                prop='regional'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.regional',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.regionais',
                                        :key='id + nome',
                                        :label='nome',
                                        :value='id'
                                    )
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.tipoContrato")',
                                prop='tipoContratoOffline'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.tipoContratoOffline',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='(tipoContrato, index) in opcoes.tiposContratoOffline',
                                        :key='index',
                                        :label='tipoContrato',
                                        :value='tipoContrato'
                                    )

                        .row
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteRegional")',
                                prop='gerenteRegional'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.gerenteRegional',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.gerentesRegionais',
                                        :key='nome + id',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteComercial")',
                                prop='gerenteComercial'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.gerenteComercial',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.gerentesComerciais',
                                        :key='nome + id',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gestorTerritorial")',
                                prop='gestorTerritorial'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.gestorTerritorial',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.gestoresTerritoriais',
                                        :key='nome + id',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.eudr")',
                                prop='eudr'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.eudr',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='({ nome, id, value }, index) in opcoes.eudr',
                                        :key='`contrato-manual-eudr-editar-${index}-${nome}`',
                                        :id='`contrato-manual-eudr-editar-${index}-${nome}`',
                                        :label='nome',
                                        :value='value'
                                    )
                        .row.mt-4
                            .col-btn.w-100.botao-submit
                                el-form-item.col-3
                                    el-button(
                                        type='primary',
                                        :disabled='editandoContrato',
                                        @click='salvarEdicao(formEdicaoContrato)'
                                    )
                                        i.el-icon.el-icon-plus
                                        | {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import RegionalService from '@/services/RegionalService';
import PessoaService from '@/services/PessoaService';
import LocalidadeService from '@/services/LocalidadeService';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';
import FormEmpresaEditarContratoAlvorada from './FormEmpresaEditarContratoAlvorada.vue';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: { BaseHeader, FormEmpresaEditarContratoAlvorada },
    data() {
        const validarVolumeRecebido = (rule, value, callback) => {
            if (value && value.toString().includes('.')) {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                (value && maisVirgulas.test(value)) ||
                (value && value.toString().startsWith(',')) ||
                (value && value.toString().endsWith(','))
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (value && !numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            // if (parseFloat(value.toString().replace(',', '.')) <= 0) {
            //     callback(
            //         new Error(
            //             this.$t(
            //                 'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
            //             )
            //         )
            //     );
            //     return;
            // }

            callback();
        };

        const validarValorContrato = (rule, value, callback) => {
            if (value !== '') {
                if (value.toString().includes('.')) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                            )
                        )
                    );
                    return;
                }

                const maisVirgulas = /.*,.*,.*/;
                if (
                    maisVirgulas.test(value) ||
                    value.toString().startsWith(',') ||
                    value.toString().endsWith(',')
                ) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                            )
                        )
                    );
                    return;
                }

                const numeroVirgula = /^[\d,]+$/;
                if (!numeroVirgula.test(value)) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                            )
                        )
                    );
                    return;
                }

                if (parseFloat(value.toString().replace(',', '.')) < 0) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                            )
                        )
                    );
                    return;
                }
            }

            callback();
        };

        return {
            formEdicaoContrato: {
                id: '',
                numeroContrato: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                volumeRecebido: '',
                dataContrato: '',
                fornecedor: null,
                cnpjFornecedor: '',
                segmento: '',
                canal: '',
                regional: '',
                estado: '',
                municipio: '',
                gerenteComercial: '',
                gerenteRegional: '',
                gestorTerritorial: '',
                fornecedorParceiroId: '',
                subEmpresaId: '',
                valorContrato: '',
                condicaoFrete: '',
                dataPagamento: '',
                localCondicaoFrete: '',
                tipoContratoOffline: '',
                eudr: undefined
            },

            formEdicaoContratoRegras: {
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                volumeRecebido: [
                    {
                        required: false,
                        validator: validarVolumeRecebido,
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cnpjFornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                segmento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                canal: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                regional: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                estado: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                municipio: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                gerenteComercial: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                gerenteRegional: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                gestorTerritorial: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                eudr: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.error.campoEudr'
                        ),
                        trigger: 'change'
                    }
                ],
                tipoContratoOffline: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                valorContrato: [
                    {
                        required: false,
                        validator: validarValorContrato,
                        trigger: 'blur'
                    }
                ],
                condicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataPagamento: [
                    {
                        required: false,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                localCondicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },

            opcoes: {
                culturas: [],
                safras: [],
                fornecedores: [],
                cnpjFornecedores: [],
                segmentos: [],
                canais: [],
                regionais: [],
                estados: [],
                municipios: [],
                gerentesRegionais: [],
                gerentesComerciais: [],
                gestoresTerritoriais: [],
                clientes: [],
                tiposContratoOffline: [],
                eudr: [
                    {
                        nome: this.$t('mensagens.comuns.sim'),
                        id: 1,
                        value: true
                    },
                    {
                        nome: this.$t('mensagens.comuns.nao'),
                        id: 2,
                        value: false
                    }
                ]
            },

            tipoPessoa: {
                GERENTE_REGIONAL: 'gerentesRegionais',
                GERENTE_COMERCIAL: 'gerentesComerciais',
                GERENTE_TERRITORIAL: 'gestoresTerritoriais'
            },

            editandoContrato: false,
            carregando: false,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            },

            loading: {
                fornecedor: true
            }
        };
    },
    computed: {
        ...mapGetters(['isAlvorada', 'usuarioLogado', 'trading']),

        isBunge() {
            return this.usuarioLogado.isBunge;
        },

        getTrading() {
            return this.trading;
        }
    },
    async mounted() {
        this.carregando = true;

        await this.buscarEstados();
        await this.buscarCulturas();
        await this.buscarSafras();
        await this.buscarSegmentos();
        await this.buscarCanais();
        await this.buscarRegionais();
        await this.buscarPessoas('GERENTE_REGIONAL');
        await this.buscarPessoas('GERENTE_COMERCIAL');
        await this.buscarPessoas('GERENTE_TERRITORIAL');
        await this.buscarClientes();

        this.buscarFornecedores();
        this.buscarTiposContrato();

        this.buscarDados();
    },
    methods: {
        async buscarFornecedores() {
            try {
                this.loading.fornecedor = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();

                this.opcoes.fornecedores = data;
                this.loading.fornecedor = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
        },
        async buscarDados() {
            await ContratoOriginacaoServiceEmpresa.buscarContratoEdicao(
                this.$route.params.id
            )
                .then(async ({ data }) => {
                    await this.buscarMunicipios(
                        data.dadosContratoOriginacao.estadoId
                    );

                    this.formEdicaoContrato = {
                        id: data.dadosContratoOriginacao.id,
                        numeroContrato:
                            data.dadosContratoOriginacao.numeroContrato,
                        cultura: data.dadosContratoOriginacao.materialId,
                        safra: data.dadosContratoOriginacao.safraId,
                        volumeContratado:
                            data.dadosContratoOriginacao.volumeContratado,
                        volumeRecebido:
                            data.dadosContratoOriginacao.volumeRecebido,
                        dataContrato: new Date(
                            data.dadosContratoOriginacao.dataContrato
                        ),
                        fornecedor:
                            data.dadosContratoOriginacao.fornecedorParceiroNome,
                        cnpjFornecedor:
                            data.dadosContratoOriginacao.subEmpresaCnpj,
                        segmento: data.dadosContratoOriginacao.segmentoId,
                        canal: data.dadosContratoOriginacao.canalId,
                        regional: data.dadosContratoOriginacao.regionalId,
                        estado: data.dadosContratoOriginacao.estadoId,
                        municipio: data.dadosContratoOriginacao.municipioId,
                        gerenteComercial:
                            data.dadosContratoOriginacao.gerenteComercialId,
                        gerenteRegional:
                            data.dadosContratoOriginacao.gerenteRegionalId,
                        gestorTerritorial:
                            data.dadosContratoOriginacao.gestorTerritorialId,
                        fornecedorParceiroId:
                            data.dadosContratoOriginacao.fornecedorParceiroId,
                        subEmpresaId: data.dadosContratoOriginacao.idSubEmpresa,
                        valorContrato:
                            data.dadosContratoOriginacao.valorContrato,
                        condicaoFrete:
                            data.dadosContratoOriginacao.condicaoFrete,
                        dataPagamento:
                            data.dadosContratoOriginacao.dataPagamento &&
                            data.dadosContratoOriginacao.dataPagamento !== '--'
                                ? new Date(
                                      data.dadosContratoOriginacao.dataPagamento
                                  )
                                : null,
                        localCondicaoFrete:
                            data.dadosContratoOriginacao.localCondicaoFrete,
                        tipoContratoOffline:
                            data.dadosContratoOriginacao.tipoContratoOffline,
                        clienteDocumentoId:
                            data.dadosContratoOriginacao.clienteDocumentoId,
                        clienteId: data.dadosContratoOriginacao.clienteId,
                        codigoExterno:
                            data.dadosContratoOriginacao.codigoExterno,
                        eudr: data.dadosContratoOriginacao.eudr
                    };

                    setTimeout(() => (this.carregando = false), 500);
                })
                .catch(error => {
                    setTimeout(() => (this.carregando = false), 500);
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },

        async buscarCulturas() {
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();

                this.opcoes.culturas = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async buscarSegmentos() {
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarSegmentos();

                this.opcoes.segmentos = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSegmento'
                    )
                );
            }
        },

        async buscarCanais() {
            try {
                const { data } = await ContratoOriginacaoService.buscarCanais();

                this.opcoes.canais = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCanal'
                    )
                );
            }
        },

        async buscarRegionais() {
            try {
                const { data } = await RegionalService.buscarRegionais();

                this.opcoes.regionais = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarRegional'
                    )
                );
            }
        },

        async buscarEstados() {
            try {
                const { data } = await LocalidadeService.findEstados(false);

                this.opcoes.estados = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async buscarMunicipios(idEstado) {
            if (idEstado != null && idEstado !== undefined && idEstado !== '') {
                try {
                    const { data } = await LocalidadeService.findMunicipios(
                        idEstado,
                        false
                    );

                    this.opcoes.municipios = data;
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarMunicipios'
                        )
                    );
                }
            }
        },

        async buscarPessoas(codigoTipoPessoa) {
            try {
                const tipoPessoa = this.tipoPessoa[codigoTipoPessoa];

                const { data } = await PessoaService.buscarPessoa(
                    codigoTipoPessoa
                );
                this.opcoes[tipoPessoa] = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarGerentes'
                    )
                );
            }
        },

        async buscarClientes() {
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarClientes();

                this.opcoes.clientes = data;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os clientes.');
            }
        },

        async definirCnpjFornecedor() {
            this.formEdicaoContrato.cnpjFornecedor = '';
            this.$refs['formEdicaoContratoRef'].fields
                .find(f => f.labelFor === 'cnpjFornecedor')
                .resetField();

            if (this.formEdicaoContrato.fornecedor) {
                this.opcoes.cnpjFornecedores =
                    this.formEdicaoContrato.fornecedor.cpfCnpj;
            }
        },

        buscarTiposContrato() {
            this.opcoes.tiposContratoOffline = ['Online', 'Offline'];
        },

        selecaoCondicaoFrete() {
            this.formEdicaoContrato.localCondicaoFrete = '';
        },
        alteradoEstado() {
            this.formEdicaoContrato.municipio = '';
            this.buscarMunicipios(this.formEdicaoContrato.estado);
        },
        salvarEdicao() {
            this.$refs['formEdicaoContratoRef'].validate(async valid => {
                if (valid) {
                    this.editandoContrato = true;
                    this.carregando = true;

                    if (
                        typeof this.formEdicaoContrato.numeroContrato ===
                            'string' &&
                        this.formEdicaoContrato.numeroContrato.indexOf('-') !==
                            -1
                    ) {
                        this.formEdicaoContrato.numeroContrato =
                            this.formEdicaoContrato.numeroContrato.replace(
                                '-',
                                ''
                            );
                    }

                    ContratoOriginacaoServiceEmpresa.editarContrato({
                        id: this.formEdicaoContrato.id,
                        numeroContrato: this.formEdicaoContrato.numeroContrato,
                        idMaterial: this.formEdicaoContrato.cultura,
                        idSafra: this.formEdicaoContrato.safra,
                        volumeContratado: parseFloat(
                            this.formEdicaoContrato.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        volumeRecebido: parseFloat(
                            this.formEdicaoContrato.volumeRecebido.replace(
                                ',',
                                '.'
                            )
                        ),
                        valorDataContrato:
                            this.formEdicaoContrato.dataContrato.getTime(),
                        fornecedorParceiroId:
                            this.formEdicaoContrato.fornecedorParceiroId,
                        idSubEmpresa:
                            this.formEdicaoContrato.fornecedor.idEmpresa,
                        subEmpresaCnpj: this.formEdicaoContrato.cnpjFornecedor,
                        idSegmento: this.formEdicaoContrato.segmento,
                        idCanal: this.formEdicaoContrato.canal,
                        idRegional: this.formEdicaoContrato.regional,
                        idMunicipio: this.formEdicaoContrato.municipio,
                        idGerenteComercial:
                            this.formEdicaoContrato.gerenteComercial,
                        idGestorTerritorial:
                            this.formEdicaoContrato.gestorTerritorial,
                        idGerenteRegional:
                            this.formEdicaoContrato.gerenteRegional,
                        valorContrato: parseFloat(
                            this.formEdicaoContrato.valorContrato
                                .replace(/\./g, '')
                                .replace(',', '.')
                        ),
                        condicaoFrete: this.formEdicaoContrato.condicaoFrete,
                        valorDataPagamento: this.formEdicaoContrato
                            .dataPagamento
                            ? this.formEdicaoContrato.dataPagamento.getTime()
                            : '',
                        localCondicaoFrete:
                            this.formEdicaoContrato.localCondicaoFrete,
                        tipoContratoOffline:
                            this.formEdicaoContrato.tipoContratoOffline ===
                            'Offline',
                        eudr: this.formEdicaoContrato.eudr
                    })
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                                ) +
                                    ' ' +
                                    this.formEdicaoContrato.numeroContrato +
                                    ' ' +
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoAlterado'
                                    )
                            );
                            this.redirecionar();
                        })
                        .catch(error => {
                            if (
                                error.response.status === 405 ||
                                error.response.status === 400
                            ) {
                                this.$notify.error({
                                    message: error.response.data.message
                                });
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroEditarContrato'
                                    )
                                );
                            }
                        })
                        .finally(() => {
                            this.carregando = false;
                        });
                } else {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }
            });
        },
        volumeContratadoFormatado() {
            this.formEdicaoContrato.volumeContratado =
                formatters.formatarTonelada(
                    this.formEdicaoContrato.volumeContratado
                );
        },
        volumeRecebidoFormatado() {
            this.formEdicaoContrato.volumeRecebido =
                formatters.formatarTonelada(
                    this.formEdicaoContrato.volumeRecebido
                );
        },
        valorContratoFormatado() {
            this.formEdicaoContrato.valorContrato =
                this.formEdicaoContrato.valorContrato.replace(/\s/g, '');
        },
        redirecionar() {
            this.editandoContrato = false;
            this.$router.push({ path: '/rastreabilidade/empresa' });
        },
        confereFormatacao(valor) {
            return valor.includes('-') ? valor.replace('-', '') : valor;
        }
    }
};
</script>

<style lang="scss">
#editar-contrato-originacao {
    .editar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }

    .el-form-item__content {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        width: 100%;
    }

    .editar-contrato-originacao__card {
        gap: 10px;
        display: grid;

        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }

        .el-card {
            border-radius: 15px;
        }

        .el-collapse-item {
            border-radius: 10px;
            overflow: hidden;
        }

        .el-collapse-item__content {
            padding: 0px;
        }

        .el-form-item {
            padding: 0 4px;
        }

        .el-select,
        .el-input,
        .el-date-picker,
        .el-button {
            width: 100%;
        }

        .row {
            align-items: flex-end;
            margin-bottom: 15px;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label::before,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:before {
            content: none !important;
            margin-right: 0px !important;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label:after,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:after {
            content: '*';
            color: #f56c6c;
            margin-left: 4px;
        }
    }
    .botao-submit {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
